'use client';

import React from 'react';
import { useTranslation } from '@/lib/i18n';
import { X } from 'lucide-react';

interface UnsubscribedSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UnsubscribedSuccessModal: React.FC<UnsubscribedSuccessModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-100" onClick={onClose} />

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-101 pointer-events-none">
        <div className="bg-[#2A2A2A] rounded-xl p-6 max-w-md w-full mx-4 pointer-events-auto shadow-lg">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-medium text-white">{t('Unsubscribed Successfully')}</h2>
            <button
              onClick={onClose}
              className="text-white hover:text-text-tertiary transition-colors"
            >
              <X size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="text-text-secondary text-sm mb-8">
            <p>
              {t(
                'You can continue to use benefits until your plan expires. Contact hi@pythra.ai if need further help.',
              )}
            </p>
          </div>

          {/* OK Button */}
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="bg-[#4A4A4A] text-white px-6 py-2 rounded-lg hover:bg-[#5A5A5A] transition-colors"
            >
              {t('OK')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnsubscribedSuccessModal;
